import React, { useState } from "react";
import styles from "./OrderRow.module.scss";
import NewModal from "../../shared/newModal/NewModal";
import editBtn from "../../../assets/images/otp/Frame 2087326387 (1).svg";
import deleteBtn from "../../../assets/images/otp/delete-2-svgrepo-com.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { setUserName } from "../../../redux/Slices/referalMainAcc";
import { formatDate } from "../../../extentions/date";
import EyeImg from "../../../assets/images/courier/Eye (1).svg";
import DetailModal from "../../shared/detailModal/DetailModal";
import { CourierServices } from "../../../services/courier.service";
interface OrderRowProps {
  id?: number;
  address?: string;
  date?: string;
  payment_type?: string;
  delivery_amount?: string;
  total_amount?: string;
  status?: string;
  azerpost_track?: string;
  otp?: string;
  message?: string;
  otp_code?: string;
  otp_text?: string;
  onEdit?: () => void;
  surname?: string;
  name?: string;
  balance?: string;
  referal?: boolean;
  promoCode?: boolean;
  code?: string;
  used_at?: string;
  attornary?: boolean;
  patronymic?: string;
  passport_series?: string;
  passport_number?: string;
  passport_fin?: string;
  birthday?: string;
  phone?: string;
  onDelete?: () => void;
  watchPackages?: boolean;
  original_track?: string;
  last_status_date?: string;
  displayed_weight?: string;
  delivery_original_amount?: string;
  setLoading?: (value: boolean) => void;
  trendyol?: boolean;
  subject?: string;
  created_at?: string;
  expired_at?: string;
  Courier?: boolean;
  order?: void;
  SelectedPackages?: boolean;
  track?: string;
  Azerpost?: boolean;
  external_w_debt?: string | null;
  internal_w_debt?: string | null;
  amount?: string;
  full_name?: string;
  AllReferals?: boolean;
  country?: string;
  flight?: string | null;
  unit?: string;
  package_delivery_amount_icon?: string;
  phone_prefix?: string;
  status_color?: string;
  country_name?: string;
  category_name?: string;
  seller?: string;
  invoice_price_icon?: string;
  invoice_price?: string;
  paid_status?: number;
  discounted_amount?: number | null;
  discount_color?: string;
  invoice_doc?: string | null;
  expired_date?: string;
}

const OrderRow: React.FC<OrderRowProps> = ({
  address,
  date,
  phone_prefix,
  payment_type,
  delivery_amount,
  total_amount,
  status,
  id,
  azerpost_track,
  otp,
  message,
  otp_code,
  otp_text,
  onEdit,
  surname,
  package_delivery_amount_icon,
  name,
  referal,
  promoCode,
  code,
  used_at,
  attornary,
  patronymic,
  passport_series,
  passport_number,
  passport_fin,
  birthday,
  phone,
  onDelete,
  original_track,
  watchPackages,
  last_status_date,
  displayed_weight,
  delivery_original_amount,
  setLoading,
  trendyol,
  subject,
  created_at,
  expired_at,
  Courier,
  order,
  country,
  SelectedPackages,
  track,
  Azerpost,
  external_w_debt,
  internal_w_debt,
  amount,
  full_name,
  AllReferals,
  flight,
  unit,
  status_color,
  country_name,
  category_name,
  seller,
  invoice_price,
  invoice_price_icon,
  invoice_doc,
  paid_status,
  discounted_amount,
  discount_color,
  expired_date,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [selectedOrder, setSelectedOrder] = useState<OrderRowProps | null>(
    null
  );
  const { data } = useSelector((state: RootState) => state.translationData);

  const [loadingDetail, setLoadingDetail] = useState(false);

  const [detailData, setDetailData] = useState<any>(null);
  const handleShowDetailModal = async (orderId: number) => {
    if (!orderId) return;
    setLoadingDetail(true);
    const { data, status } = await CourierServices.getCourierDetail(orderId);
    setLoadingDetail(false);

    if (status === 200) {
      setDetailData(data.original.packages);
      setShowDetailModal(true);
    } else {
    }
  };

  return (
    <>
      <tr className={styles.WebTable_body}>
        {/* AllReferals */}
        {AllReferals && <td>{full_name}</td>}
        {AllReferals && <td>{original_track}</td>}
        {AllReferals && <td>{flight || "-"}</td>}
        {AllReferals && <td>{country_name}</td>}
        {AllReferals && (
          <td>
            {displayed_weight} {unit}
          </td>
        )}
        {/* {AllReferals && <td>{category_name}</td>} */}
        {AllReferals && <td>{seller || "-"}</td>}
        {AllReferals && (
          <td>
            <span className={`${styles.invoiceBadge} ${invoice_doc ? styles.has : styles.none}`}>
              {invoice_doc ? data?.invoice_uploaded : data?.invoice_not_uploaded}
            </span>
          </td>
        )}
        {AllReferals && (
          <td>{paid_status === 1 ? data?.paid : data?.unpaid}</td>
        )}
        {AllReferals && (
          <td>
            {invoice_price} {invoice_price_icon}
          </td>
        )}
        {AllReferals && (
          <td>
            {delivery_original_amount} {package_delivery_amount_icon}
          </td>
        )}
        {AllReferals && (
          <td> {last_status_date ? formatDate(last_status_date) : "-"}</td>
        )}

        {/* ///////////////// */}
        {watchPackages && <td>{original_track}</td>}
        {watchPackages && (
          <td> {last_status_date ? formatDate(last_status_date) : "-"}</td>
        )}
        {watchPackages && <td>{displayed_weight}</td>}
        {watchPackages && <td>{delivery_original_amount}</td>}
        {watchPackages && (
          <td>
            <span className={`${styles.invoiceBadge} ${invoice_doc ? styles.has : styles.none}`}>
              {invoice_doc ? data?.invoice_uploaded : data?.invoice_not_uploaded}
            </span>
          </td>
        )}

        {promoCode && <td>{code}</td>}
        {promoCode && <td>{country_name || "-"}</td>}
        {promoCode && <td>{used_at ? used_at : "-"}</td>}
        {promoCode && <td>{expired_date ? formatDate(expired_date) : "-"}</td>}

        {/* Rferal */}
        {referal && <td>{id}</td>}
        {referal && <td>{[name, surname].filter(Boolean).join(" ")}</td>}
        {referal && (
          <td className={styles.buttons}>
            {/* <button
              onClick={() => {
                navigate(`/account/referal/referal-packages/${id}`);
                dispatch(
                  setUserName([name, surname].filter(Boolean).join(" "))
                );
              }}
              className={styles.packagesBtn}
            >
              Bağlamaları gör
            </button> */}
            <button
              className={styles.accountBtn}
              onClick={() => {
                setShowModal(true);
              }}
            >
              {data?.auth_referal_login_account}
            </button>
          </td>
        )}

        {azerpost_track && <td>{azerpost_track}</td>}
        {address && <td>{address}</td>}
        {date && <td>{date}</td>}
        {(Courier || Azerpost) && <td>{payment_type}</td>}
        {(Azerpost || Courier) && (
          <td>
            {delivery_amount}
            <span style={{ marginLeft: "10px" }}>AZN</span>
          </td>
        )}
        {(Azerpost || Courier) && (
          <td>
            {amount}
            <span style={{ marginLeft: "10px" }}>AZN</span>
          </td>
        )}
        {(Azerpost || Courier) && (
          <td>
            {total_amount}
            <span style={{ marginLeft: "10px" }}>AZN</span>
          </td>
        )}

        {otp_code && <td>{otp_code}</td>}
        {otp_text && <td>{otp_text}</td>}
        {otp_text && <td>{country}</td>}
        {otp_text && (
          <td>
            <img
              src={editBtn}
              alt="edit"
              onClick={onEdit}
              style={{ cursor: "pointer" }}
            />
          </td>
        )}
        {status && (
          <td>
            <p
              style={{ backgroundColor: status_color }}
              className={styles.status}
            >
              {status}
            </p>
          </td>
        )}

        {Courier && (
          <td>
            <img
              src={EyeImg}
              alt=""
              onClick={() => handleShowDetailModal(id!)}
              style={{ cursor: "pointer" }}
            />
          </td>
        )}

        {Azerpost && (
          <td>
            <img
              src={EyeImg}
              alt=""
              onClick={() => handleShowDetailModal(id!)}
              style={{ cursor: "pointer" }}
            />
          </td>
        )}
        {attornary && <td>{name}</td>}
        {attornary && <td>{surname}</td>}
        {attornary && <td>{patronymic}</td>}
        {attornary && <td>{passport_series}</td>}
        {attornary && <td>{passport_number}</td>}
        {attornary && <td>{passport_fin}</td>}
        {attornary && <td>{birthday}</td>}
        {attornary && (
          <td>
            +994
            {phone_prefix}
            {phone}
          </td>
        )}
        {attornary && (
          <td>
            <div className={styles.setting}>
              <img src={editBtn} alt="" onClick={onEdit} />
              <img
                style={{ width: "24px", height: "24px" }}
                src={deleteBtn}
                alt=""
                onClick={onDelete}
              />
            </div>
          </td>
        )}

        {/* trendyol */}
        {trendyol && <td>{code}</td>}
        {trendyol && <td>{subject}</td>}
        {trendyol && <td>{message}</td>}
        {trendyol && <td>{created_at}</td>}
        {trendyol && <td>{expired_at}</td>}

        {/* ////////////selected */}

        {SelectedPackages && <td className={styles.selectedTrack}>{track}</td>}
        {SelectedPackages && (
          <td className={styles.selectedTrack}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "2px" }}>
              {discount_color && (
                <span
                  style={{
                    color: discount_color,
                    textDecoration: "line-through",
                    fontSize: "12px",
                  }}
                >
                  {amount} AZN
                </span>
              )}
              <span>
                {discount_color
                  ? discounted_amount
                  : amount}{" "}
                AZN
              </span>
            </div>
          </td>
        )}
        {SelectedPackages && (
          <td className={styles.selectedTrack}>
            {external_w_debt} <span style={{ marginLeft: "5px" }}>AZN</span>
          </td>
        )}
        {SelectedPackages && (
          <td className={styles.selectedTrack}>
            {internal_w_debt} <span style={{ marginLeft: "5px" }}>AZN</span>
          </td>
        )}
      </tr>

      {showDetailModal && detailData && (
        <DetailModal
          title=""
          content="Bağlama Detalları"
          onClose={() => setShowDetailModal(false)}
          musteriId={id}
          orderData={detailData}
          setShowModal={setShowDetailModal}
        />
      )}

      {showModal && (
        <NewModal
          title=""
          content={data?.switch_account_confirm}
          onClose={() => setShowModal(false)}
          confirmText={data?.auth_logout_yes}
          cancelText={data?.auth_logout_no}
          musteriId={id}
          setShowModal={setShowModal}
          setLoading={setLoading ?? (() => {})}
        />
      )}
    </>
  );
};

export default OrderRow;
